import classNames from 'classnames';
import { useLayoutEffect, useRef, useState } from 'react';

import './FoldableSection.scss';

/**
 * @param {Object} props
 * @param {*} [props.contentVersion] Любое значение, которое меняется вместе с
 * содержимым. Высота секции измеряется один раз на раскрытии, поэтому контент,
 * приезжающий асинхронно (отчеты архивного проекта), без этого обрезался бы.
 */
export default function FoldableSection({ children, className, expanded, onTransitionEnd, contentVersion }) {

  const ref = useRef();

  const [height, setHeight] = useState(0);
  const [animated, setAnimated] = useState(!expanded);

  useLayoutEffect(() => {
    setHeight(expanded ? (ref.current?.scrollHeight ?? 0) : 0);
    if (!animated && height)
      setAnimated(true);
  }, [animated, expanded, height, contentVersion]);

  const header = children?.[0] ?? children;
  const data = children?.[1];

  return (
    <div className={classNames('foldable-section', className)}>
      {header && <div className='foldable-section__header'>
        {header}
      </div>}
      {data &&
        <div
          ref={ref}
          style={{ height: height }}
          className={classNames('foldable-section__main', animated ? 'foldable-section__main_animated' : '')}
          onTransitionEnd={onTransitionEnd}
        >
          {data}
        </div>
      }
    </div>
  );
}
